module.exports = __webpack_public_path__ + "static/media/undraw_personal_text.cdca924a.svg";